var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-3",style:({
    'background': _vm.config.background,
    'border-radius': _vm.config.isRadio ? '5px' : 0,
    fontFamily:_vm.config.fontFamily?_vm.config.fontFamily:'auto',
  })},[(_vm.config.title.show)?_c('div',{staticClass:"opacity-08 card-3-title",style:({
      lineHeight: _vm.config.title.lineHeight+'px',
      color: _vm.config.title.color,
      fontSize: _vm.config.title.fontSize + 'px',
      marginLeft: _vm.config.title.offsetX + 'px',
    })},[_vm._v("\n    "+_vm._s(_vm.config.title.text)+"\n  ")]):_vm._e(),_c('div',{staticClass:"m-count opacity-08",style:({
      color: _vm.config.count.color,
      fontSize: _vm.config.count.fontSize + 'px',
      marginLeft: _vm.config.count.offsetX + 'px',
      margin:_vm.arrayToPx(_vm.config.count.margin),
      fontWeight:_vm.config.count.fontWeight
    })},[_vm._v("\n    "+_vm._s(_vm.getCount)+_vm._s(_vm.config.count.company)+"\n  ")]),_c('div',{staticClass:"wrap opacity-08",class:[("" + (_vm.config.subitem.display === 'block'?'block-wrap':'flex-wrap'))],style:({
      color: _vm.config.subitem.color,
      display:_vm.config.subitem.display
    })},[(_vm.config.subitem1.show)?_c('div',{staticClass:"item"},[_c('div',{staticClass:"name",style:({
          fontSize: _vm.config.subitem.fontSizeName+ 'px'
        })},[_vm._v("\n        "+_vm._s(_vm.config.subitem1.text)+"\n      ")]),_c('div',{staticClass:"count",class:[parseFloat(_vm.chartData[0][_vm.config['c1Field']]) < 0 ? 'green' : 'red'],style:({
          fontSize: _vm.config.subitem.fontSizeCount+ 'px',
          marginLeft:_vm.config.subitem.offsetX+ 'px'
        })},[_vm._v("\n        "+_vm._s(_vm.numberSplitWithComma(_vm.chartData[0][_vm.config['c1Field']]))+"\n      ")])]):_vm._e(),(_vm.config.subitem2.show)?_c('div',{staticClass:"item",style:(Object.assign({}, _vm.itemBotStyleMargin(_vm.config.subitem.display,_vm.config.subitem.subitemGap)))},[_c('div',{staticClass:"name",style:({
          fontSize: _vm.config.subitem.fontSizeName+ 'px'
        })},[_vm._v("\n        "+_vm._s(_vm.config.subitem2.text)+"\n      ")]),_c('div',{staticClass:"count",class:[parseFloat(_vm.chartData[0][_vm.config['c2Field']]) < 0 ? 'green' : 'red'],style:({
          fontSize: _vm.config.subitem.fontSizeCount+ 'px',
          marginLeft:_vm.config.subitem.offsetX+ 'px'
        })},[_vm._v("\n        "+_vm._s(_vm.numberSplitWithComma(_vm.chartData[0][_vm.config['c2Field']]))+"\n      ")])]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }